<!--
 * @Author: 汪俊洪
 * @Date: 2025-04-27 10:41:05
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-06-17 19:12:18
 * @Description:
-->
<template>
  <div class="wrap">
    <div style="flex: 1; overflow: hidden">
      <el-table
        class="plc-table plc-table-checkbox"
        height="100%"
        :data="tableData"
        style="width: 100%"
        row-key="plcSkuId"
        ref="multipleTable"
        v-loading="dataListLoading"
        @selection-change="handleSelectionChange"
        :row-class-name="
          ({ row }) => (row.invalidStateSku ? 'row-disabled' : '')
        "
      >
        <el-table-column
          type="selection"
          :selectable="(row) => !row.invalidStateSku"
          align="center"
          width="55"
        >
        </el-table-column>
        <el-table-column
          prop="date"
          header-align="center"
          width="370px"
          label="商品信息"
        >
          <template slot-scope="scope">
            <div class="goods-info">
              <div>
                <el-image
                  class="fileUrl"
                  :src="scope.row.fileUrl"
                  :preview-src-list="[scope.row.fileUrl]"
                >
                </el-image>
                <span class="invalidStateSku" v-if="scope.row.invalidStateSku"
                  >商品已失效</span
                >
              </div>
              <div class="goods-right">
                <h2 class="skuName ell_two">{{ scope.row.skuName }}</h2>
                <div class="plc-des">
                  <span class="plc-des-label">型号：</span>
                  <span class="plc-des-value">{{ scope.row.model }}</span>
                </div>
                <div class="plc-des">
                  <span class="plc-des-label">规格：</span>
                  <span class="plc-des-value">{{
                    scope.row.specification
                  }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="discountSellingPrice"
          label="单价（元）"
        >
          <template slot-scope="scope">
            <div class="plc-des nowrap">
              <span class="plc-des-label">价格：</span>
              <span class="plc-des-value show-money"
                >￥{{ scope.row.discountSellingPrice | formatePrice }}</span
              >
            </div>
            <div class="plc-des">
              <span class="plc-des-label">折扣：</span>
              <span class="plc-des-value"
                >{{ (scope.row.discountRate || 0) * 10 }}折</span
              >
            </div>
            <div class="plc-des">
              <span class="plc-des-label">标准价：</span>
              <span class="plc-des-value">{{
                scope.row.sellingPrice | formatePrice
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="plcSkuCode" align="center" label="中控物料编码">
        </el-table-column>
        <el-table-column prop="skuCode" align="center" label="平台编码">
        </el-table-column>
        <el-table-column prop="goodsNum" align="center" label="数量">
          <template slot-scope="scope">
            <el-input-number
              size="mini"
              class="plc-input-number"
              v-model="scope.row.goodsNum"
              :min="1"
              :max="99999999"
              @change="changeNum(scope.row)"
              :disabled="scope.row.invalidStateSku"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="discountSellingPriceTotal"
          label="含税小计（元）"
        >
          <template slot-scope="scope">
            <span class="show-money"
              >￥{{ scope.row.discountSellingPriceTotal | formatePrice }}</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="plc-bottom">
      <!-- 底部内容1 -->
      <div class="plc-bottom1">
        <div class="btns">
          <el-checkbox
            v-model="allCheck"
            class="check-all"
            :disabled="!tableData.length || dataListLoading"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <el-button
            type="text"
            @click="() => toDelSelected(multipleSelection)"
            :disabled="dataListLoading"
            class="del-btn"
          >
            删除选中商品
          </el-button>
          <el-button
            type="text"
            @click="toClearInvalid"
            :disabled="dataListLoading"
            class="del-btn"
          >
            清空失效商品
          </el-button>
        </div>
        <div class="plc-bottom1-right">
          <div class="selected-num">
            已选择<span>{{ multipleSelection.length }}</span
            >种，共<span>{{ totalNum }}</span
            >件<span style="padding-left: 24px;"></span>应付含税金额<span>￥{{ priceAmount | formatePrice }}</span>
          </div>
          <div @click="toBuy" class="btn to-buy">去结算</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatePrice } from '@/utils/formatePrice'
import { add } from '@/utils/numberComputed'
import debounce from 'lodash/debounce'

export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    dataListLoading: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    formatePrice (val) {
      if (val) {
        if (typeof val !== 'number') {
          val = val - 0
        }
        return formatePrice(val.toFixed(2))
      }
      if (val === null) {
        return '-'
      }
      return '0.00'
    }
  },
  data () {
    return {
      multipleSelection: [],
      totalNum: 0,
      priceAmount: 0,
      allCheck: false
    }
  },
  watch: {
    multipleSelection: {
      handler (val) {
        this.computedNum()
      },
      immediate: true
    }
  },
  methods: {
    // 表单提交
    changeNum: debounce(
      function (row) {
        const obj = {
          goodsNum: row.goodsNum,
          plcSkuId: row.plcSkuId
        }
        this.$http
          .post('/front/oms/plc/shoppingCart/updateShoppingCartSku', obj)
          .then(({ data: res }) => {
            if (res.code === 0) {
              // this.$message({
              //   type: 'success',
              //   duration: 1000,
              //   message: '操作成功'
              // })
              this.bus.$emit('getCurrentUserCount')
              this.$emit('refresh')
            }
          })
      },
      700,
      { leading: false, trailing: true }
    ),
    // 底部全选
    handleCheckAllChange (val) {
      let multipleTable = this.$refs.multipleTable
      if (val) {
        multipleTable.toggleAllSelection()
      } else {
        multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (val.length && val.length === this.tableData.length) {
        this.allCheck = true
      } else {
        this.allCheck = false
      }
    },
    computedNum () {
      let totalNum = 0
      let priceAmount = 0
      this.multipleSelection.forEach((item) => {
        totalNum = add(totalNum, item.goodsNum)
        priceAmount = add(priceAmount, item.discountSellingPriceTotal)
      })
      this.totalNum = totalNum
      this.priceAmount = priceAmount
    },
    // 删除选中商品
    toDelSelected (arr) {
      if (!arr.length) {
        return this.$message.warning('请选择要删除的商品')
      }
      const obj = {
        plcCartIdList: arr.map((item) => item.plcCartId)
      }
      this.$http
        .post('/front/oms/plc/shoppingCart/deleteShoppingCartSku', obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.bus.$emit('getCurrentUserCount')
            this.$message({
              type: 'success',
              duration: 1000,
              message: '操作成功'
            })
            this.$emit('refresh')
          }
        })
    },
    // 清空失效商品
    toClearInvalid () {
      const arr = this.tableData.filter((i) => i.invalidStateSku)
      if (!arr.length) {
        return this.$message.warning('没有失效商品')
      }
      this.toDelSelected(arr)
    },
    toBuy () {
      if (!this.multipleSelection.length) {
        return this.$message.warning('请先选中商品')
      }
      const t = new Date().getTime()
      const obj = {
        t,
        itemList: this.multipleSelection
      }
      sessionStorage.setItem('plcOrderAdd', JSON.stringify(obj))
      this.$router.push({
        path: '/plcOrderAdd',
        query: {
          t
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.goods-info {
  display: flex;
  align-items: center;
  .fileUrl {
    width: 131px;
    margin-right: 16px;
  }
  .skuName {
    font-size: 14px;
    font-weight: 700;
    color: #333333;
    margin: 0 0 14px;
  }
  .goods-right {
    flex: 1;
  }
}

.plc-des {
  text-align: left;
  margin-bottom: 9px;
}

.show-money {
  font-size: 20px;
  font-weight: 900;
  color: #e93037;
}

.plc-bottom {
  .plc-bottom1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 9.5px 16px;
    flex: 1;
  }
  .selected-num {
    font-size: 12px;
    color: #000;
    span {
      color: #ff0000;
    }
  }
  .plc-bottom1-right {
    display: flex;
    align-items: center;
    .btn {
      font-size: 18px;
      font-weight: bold;
      line-height: 20px;
      margin-left: 12px;
      padding: 8px 12px;
      background: #2a54d1;
      border-radius: 8px;
      color: #fff;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      &.to-buy {
        background: #ff4c2b;
      }
    }
  }
  .plc-pagination {
    border-top: 1px solid #eeeeee;
  }
  .del-btn {
    color: #ff4c2b;
    margin-left: 26px;
  }
}

.nowrap {
  white-space: nowrap;
}
</style>
